<template>
  <div>
    <Input textType="file" :multiFile="true" @fileChanged="documentSelected" placeholder="Select Documents" />
    <!-- <Attachments /> 

    <div class='pv-details' v-show="data['Document Type'] =='Payment'">
      <p>{{data['Document Type'] =='Payment'? 'Payment No' : 'Transaction No'}}: {{data['PaymentNo']? data['PaymentNo'] : data['TxnID'] }}</p>
      <p>Issued To: {{data['IssuedTo']}}</p>
      <p>Total Amount: {{data['Currency']}} {{data['Total Amount']}}</p>
      <p>Issued Date: {{data['Date Issued']}}</p>
      <p>Requested by: {{data['User ID']}}</p>
      <p>Remarks: {{data['Remark']}}</p>
    </div> -->

  </div>
</template>

<script>
/* eslint-disable */
import Attachments from '@/components/tabComponents/Attachments.vue';
import Input from '@/components/Input.vue';

export default {
  components: {
    Attachments, Input
  },
  props: {
    attachment: {type: Object, default: function() { return null } },
    attachmentSelected: {type: Object, default: function() { return null } },
  },
  methods: {
    documentSelected: function(att, placeholder) {
      console.log(att);
      console.log(placeholder);
    }
  },
  mounted() {
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

</style>